import { ACCOUNTING_API } from '../../../../config/api';

export type CanvasElementType = 'text' | 'image' | 'rect' | 'circle' | 'line' | 'statBox';

export function getProxiedImageUrl(url?: string): string {
  if (!url) return '';
  if (url.startsWith('data:')) return url;
  return `${ACCOUNTING_API.OFFER_TEMPLATE_IMAGE_PROXY}?url=${encodeURIComponent(url)}`;
}

export const PLACEHOLDERS = [
  { key: '{{müşteriAdı}}', label: 'Müşteri / Şirket Adı' },
  { key: '{{müşteriVergiNo}}', label: 'Müşteri Vergi No' },
  { key: '{{müşteriVergiDairesi}}', label: 'Müşteri Vergi Dairesi' },
  { key: '{{müşteriAdres}}', label: 'Müşteri Adres' },
  { key: '{{müşteriTelefon}}', label: 'Müşteri Telefon' },
  { key: '{{müşteriEmail}}', label: 'Müşteri E-posta' },
  { key: '{{teklifNo}}', label: 'Teklif Numarası' },
  { key: '{{teklifTarihi}}', label: 'Teklif Tarihi' },
  { key: '{{gecerlilikTarihi}}', label: 'Geçerlilik Tarihi' },
  { key: '{{firmaAdı}}', label: 'Firma Adı' },
  { key: '{{firmaTelefon}}', label: 'Firma Telefon' },
  { key: '{{firmaEmail}}', label: 'Firma E-posta' },
  { key: '{{firmaAdres}}', label: 'Firma Adres' },
  { key: '{{genelToplam}}', label: 'Genel Toplam' },
  { key: '{{paraBirimi}}', label: 'Para Birimi' },
  { key: '{{kdvToplam}}', label: 'KDV Toplam' },
  { key: '{{araToplam}}', label: 'Ara Toplam' },
] as const;

export interface CanvasElement {
  id: string;
  type: CanvasElementType;
  x: number;
  y: number;
  width?: number;
  height?: number;
  rotation?: number;
  opacity?: number;
  draggable?: boolean;
  text?: string;
  fontSize?: number;
  fontFamily?: string;
  fontStyle?: string;
  fill?: string;
  align?: string;
  lineHeight?: number;
  src?: string;
  fillColor?: string;
  stroke?: string;
  strokeWidth?: number;
  cornerRadius?: number;
  radiusX?: number;
  radiusY?: number;
  points?: number[];
  lineStroke?: string;
  lineStrokeWidth?: number;
  statValue?: string;
  statLabel?: string;
  statValueColor?: string;
  statLabelColor?: string;
  statValueSize?: number;
  statLabelSize?: number;
  statBgColor?: string;
  statBorderColor?: string;
}

let _counter = 0;
const uid = () => `el-${Date.now()}-${++_counter}`;

export const STAGE_WIDTH = 794;
export const STAGE_HEIGHT = 1123;

export function createTextElement(ov?: Partial<CanvasElement>): CanvasElement {
  return { id: uid(), type: 'text', x: 60, y: 200, width: 400, text: 'Metin yazın...', fontSize: 24, fontFamily: 'Arial', fontStyle: 'normal', fill: '#1a1a1a', align: 'left', lineHeight: 1.4, rotation: 0, opacity: 1, draggable: true, ...ov };
}

export function createHeadingElement(ov?: Partial<CanvasElement>): CanvasElement {
  return createTextElement({ text: 'Başlık', fontSize: 36, fontStyle: 'bold', fill: '#1a3a7a', width: 600, ...ov });
}

export function createImageElement(ov?: Partial<CanvasElement>): CanvasElement {
  return { id: uid(), type: 'image', x: 60, y: 100, width: 300, height: 200, src: '', rotation: 0, opacity: 1, draggable: true, ...ov };
}

export function createRectElement(ov?: Partial<CanvasElement>): CanvasElement {
  return { id: uid(), type: 'rect', x: 60, y: 400, width: 300, height: 180, fillColor: '#f0f4ff', stroke: '#1a3a7a', strokeWidth: 1, cornerRadius: 8, rotation: 0, opacity: 1, draggable: true, ...ov };
}

export function createCircleElement(ov?: Partial<CanvasElement>): CanvasElement {
  return { id: uid(), type: 'circle', x: 400, y: 400, radiusX: 80, radiusY: 80, fillColor: '#4a90d9', stroke: '', strokeWidth: 0, rotation: 0, opacity: 0.3, draggable: true, ...ov };
}

export function createLineElement(ov?: Partial<CanvasElement>): CanvasElement {
  return { id: uid(), type: 'line', x: 60, y: 500, points: [0, 0, 674, 0], lineStroke: '#cccccc', lineStrokeWidth: 2, rotation: 0, opacity: 1, draggable: true, ...ov };
}

export function createStatBoxElement(ov?: Partial<CanvasElement>): CanvasElement {
  return { id: uid(), type: 'statBox', x: 60, y: 600, width: 160, height: 100, statValue: '100+', statLabel: 'Müşteri', statValueColor: '#1a3a7a', statLabelColor: '#666666', statValueSize: 36, statLabelSize: 13, statBgColor: '#ffffff', statBorderColor: '#e0e0e0', cornerRadius: 8, rotation: 0, opacity: 1, draggable: true, ...ov };
}
